module.exports = __webpack_public_path__ + "img/20190103.94794f93.png";